import { render, staticRenderFns } from "./PlanItem.vue?vue&type=template&id=4aa022a8&scoped=true&"
import script from "./PlanItem.vue?vue&type=script&lang=js&"
export * from "./PlanItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa022a8",
  null
  
)

export default component.exports